import useGetLines from "@/composables/useGetLines";

export default {
  selectedLines(state) {
    return [...state.forwardLines, ...state.backwardLines];
  },

  // linesLength(state) {
  // 	return [...state.forwardLines, ...state.backwardLines].length;
  // },

  lines(state) {
    // 동일한 노선, 승차장, 하차장인 경우 terms로 묶기
    const forwardLines = JSON.parse(JSON.stringify(state.forwardLines));
    const backwardLines = JSON.parse(JSON.stringify(state.backwardLines));
    const selectedLines = [...forwardLines, ...backwardLines];
    return useGetLines(selectedLines);
  },

  forwardLines(state) {
    const forwardLines = JSON.parse(JSON.stringify(state.forwardLines));
    return useGetLines([...forwardLines]);
  },

  backwardLines(state) {
    const backwardLines = JSON.parse(JSON.stringify(state.backwardLines));
    return useGetLines([...backwardLines]);
  },

  pgList(state) {
    return state.pgList;
  },

  isForwardBookCountExceeded(state) {
    return state.isForwardBookCountExceeded;
  },

  isBackwardBookCountExceeded(state) {
    return state.isBackwardBookCountExceeded;
  },
};
